import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function PricingSection() {
  return <section id="precio" className="bg-[#0A0A0A] px-5 py-16 md:py-24" data-id="element-183">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-184">
        <motion.p variants={itemVariants} className="text-[#E8732A] text-sm md:text-base font-medium tracking-wide uppercase mb-4" data-id="element-185">
          Por qué esto funciona ahora
        </motion.p>

        <motion.p variants={itemVariants} className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-6" data-id="element-186">
          Porque el feed ya está lleno de gente compitiendo por atención.
        </motion.p>

        <motion.p variants={itemVariants} className="text-white text-xl md:text-2xl font-semibold leading-relaxed mb-8" data-id="element-187">
          El que gana no es el que "grita más".
        </motion.p>

        <motion.div variants={itemVariants} className="bg-[#141414] p-6 md:p-8 rounded-lg border border-[#2A2A2A] mb-12" data-id="element-188">
          <p className="text-[#A0A0A0] text-lg mb-4" data-id="element-189">Gana el que tiene:</p>
          <div className="space-y-2 text-white text-lg md:text-xl" data-id="element-190">
            <p data-id="element-191">• menos fricción</p>
            <p data-id="element-192">• más claridad</p>
            <p data-id="element-193">• mejor puente</p>
            <p data-id="element-194">• prueba lista</p>
          </div>
          <p className="text-[#A0A0A0] text-lg mt-6" data-id="element-195">
            Y eso se puede construir{' '}
            <span className="text-[#E8732A]" data-id="element-196">sin tener millones de views.</span>
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-gradient-to-b from-[#E8732A]/20 to-[#E8732A]/5 p-8 md:p-12 rounded-2xl border border-[#E8732A]/30 text-center" data-id="element-197">
          <p className="text-[#A0A0A0] text-lg mb-2" data-id="element-198">Oferta especial</p>
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-199">
            <span className="text-2xl md:text-3xl text-[#A0A0A0] line-through" data-id="element-200">
              $19
            </span>
            <p className="text-6xl md:text-7xl font-bold text-white" data-id="element-201">$6.39</p>
          </div>
          <p className="text-[#E8732A] font-semibold text-sm uppercase tracking-wide mb-1" data-id="element-202">
            USD
          </p>
          <p className="text-[#A0A0A0] text-lg mb-8" data-id="element-203">
            Es menos que perder una semana subiendo videos que solo entretienen.
          </p>
          <a href="https://www.rutinasimple.com/cart/51977257287961:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Vistas ≠ Ventas Toolkit',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }
        }} className="inline-block bg-[#E8732A] hover:bg-[#d4662a] text-white font-bold text-lg md:text-xl px-10 py-5 rounded-lg transition-colors duration-200 w-full md:w-auto" data-id="element-204">
            Consigue "Vistas ≠ Ventas" ahora →
          </a>
        </motion.div>
      </motion.div>
    </section>;
}